import { useSelector } from "react-redux";
import { AppStore } from "../store";
import { UserMetaData } from "./user";

export const useGetUser = () => {
  return useSelector<AppStore, UserMetaData>((store) => store.userState);
};
